import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const Article = (props) => {
    const { source, image, title, summary, url } = props;

    return (
        <div>
            <a href={url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                <div className={styles.article}>
                    <div className={styles.subTitle}>{source}</div>
                    <div className={styles.image}>
                        <img src={image} alt={title} />
                    </div>
                    <div className={styles.textPart}>
                        <h1>{title}</h1>
                        <p>{summary}</p>
                        <span>[详情]</span>
                    </div>
                </div>
            </a>

        </div>
    );
};

Article.propTypes = {
    source: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string
};

export default Article;
